import React from 'react';
import {Divider, Icon, Button, Segment, Container} from 'semantic-ui-react';

export class Left extends React.Component {
  render() {
    const {expanded, toggle} = this.props;

    if (expanded) {
      return (
        <Segment id="left" className="fullHeight leftOffset">
          <Container textAlign="right">
            <Button basic onClick={toggle} icon title="Collapse side navigation">
              <Icon name="angle double left" color="black" />
            </Button>
          </Container>
          <div id="leftNavMenuContainer">{this.props.children}</div>
        </Segment>
      );
    } else {
      return (
        <Segment id="left" className="fullHeight collapsed">
          <Button basic onClick={toggle} icon title="Expand side navigation">
            <Icon name="angle double right" color="black" />
          </Button>
        </Segment>
      );
    }
  }
}

export default Left;
